import React from 'react'
import * as Displays from 'support/displays'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import PropTypes from 'prop-types'
import { useModelKey } from '@morningtrain/react-resources'
import { useEnvValue } from '@morningtrain/react-helpers'
import * as UI from 'ui'

function SupplierCategoryItem (props) {
  const {
    categoryId
  } = props

  const itemId = useModelKey()
  const key = ['globals.inventory.supplier_categories', categoryId].join('.')
  const [items, setItems] = useEnvValue(key, [])

  const [isActive, setIsActive] = React.useState(items.includes(itemId))

  React.useEffect(() => {
    setIsActive(items.includes(itemId))
  }, [items, itemId])

  const updateChanged = (event) => {
    const isActive = event.target.checked

    setIsActive(isActive)

    let newItems = [...items]

    if (isActive) {
      newItems.push(itemId)
    } else {
      newItems = newItems.filter((id) => id !== itemId)
    }

    setItems(newItems)
  }

  return (
    <div className='flex items-center space-x-4'>
      <input type='checkbox' onChange={updateChanged} checked={isActive} />
      <UI.ProductInfo /* image={<Displays.Image name={'image'} className={'max-h-full'} />} */
        title={<Displays.Text name='name' />}
        text={(<Displays.Text name='sku' />)}
      />
    </div>
  )
}

SupplierCategoryItem.defaultProps = {}

SupplierCategoryItem.propTypes = {
  categoryId: PropTypes.number.isRequired
}

export default SupplierCategoryItem
